import React from 'react'

import {cssTheme} from '@vio/atlas/src/themes'

/** Rounded diamond anchoring the price pin to its bar. */
export const PricePinTail = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16.1205 16"
    // Figma stretches the exported path into a square 16px box.
    preserveAspectRatio="none"
    fill="none"
    aria-hidden
    {...props}
  >
    <path
      fill={cssTheme.colors.background.brand.primary}
      d="M1.41042 9.40665C0.631467 8.62351 0.633165 7.35549 1.41421 6.57444L7.07107 0.917588C7.85212 0.136539 9.11675 0.138232 9.8957 0.921369L15.5374 6.59335C16.3163 7.37649 16.3146 8.64451 15.5336 9.42556L9.87675 15.0824C9.0957 15.8635 7.83106 15.8618 7.05211 15.0786L1.41042 9.40665Z"
    />
  </svg>
)
